import type { HistogramChartTooltipProps } from '../types/histogram.js';

export const Tooltip = (props: HistogramChartTooltipProps) => null;

Tooltip['displayName'] = 'HistogramChart.Tooltip';
